export const MultiAssetPair: string[] = [
  'sol/eth',
  'eth/btc',
  'aave/ada',
  'aave/bnb',
  'aave/apt',
  'aave/avax',
  'aave/btc',
]
